//REGISTER
export const POST_FAKE_REGISTER = "/post-fake-register";

// get notifications
export const GET_NOTIFICATIONS = "/api/notification/fetch-notifications";


export const INVITE_CUSTOMER = "/api/admin/invite-customer";
//LOGIN
export const POST_FAKE_LOGIN = "/api/login";
export const POST_FAKE_JWT_LOGIN = "/api/login";
export const POST_FAKE_PASSWORD_FORGET = "/fake-forget-pwd";
export const POST_FAKE_JWT_PASSWORD_FORGET = "/jwt-forget-pwd";
export const SOCIAL_LOGIN = "/social-login";

export const GET_WAITLIST = "/api/waitlist";

//PROFILE
export const POST_EDIT_JWT_PROFILE = "/post-jwt-profile";
export const POST_EDIT_PROFILE = "/post-fake-profile";

//PRODUCTS
export const GET_PRODUCTS = "/products";
export const GET_PRODUCTS_DETAIL = "/product";

//Mails
export const GET_INBOX_MAILS = "/inboxmails";
export const ADD_NEW_INBOX_MAIL = "/add/inboxmail";
export const DELETE_INBOX_MAIL = "/delete/inboxmail";

//starred mail
export const GET_STARRED_MAILS = "/starredmails";

//important mails
export const GET_IMPORTANT_MAILS = "/importantmails";

//Draft mail
export const GET_DRAFT_MAILS = "/draftmails";

//Send mail
export const GET_SENT_MAILS = "/sentmails";

//Trash mail
export const GET_TRASH_MAILS = "/trashmails";

//CALENDER
export const GET_EVENTS = "/api/activity/get-schedule";
export const ADD_NEW_EVENT = "/api/activity/create-schedule";
export const UPDATE_EVENT = "/api/activity/update-schedule";
export const DELETE_EVENT = "/delete/event";
export const GET_CATEGORIES = "/categories";
export const GET_UPCOMING_EVENTS = "/api/activity/get-upcoming-events";

//messages
export const GET_LAST_MESSAGES = "/api/messaging/fetch-latest-messages";

//reported messages
export const GET_REPORT_MESSAGES = "/api/report-message";

//expense
export const GET_EXPENSE_CATEGORIES = "/api/expense/get-categories";
export const ADD_NEW_EXPENSE_CATEGORY = "/api/expense/create-category";
export const UPDATE_EXPENSE_CATEGORY = "/api/expense/update-category";
export const DELETE_EXPENSE_CATEGORY = "/api/expense/delete-category";

export const GET_EXPENSES = "/api/expense/get-expenses";
export const ADD_NEW_EXPENSE = "/api/expense/create-expense";
export const UPDATE_EXPENSE = "/api/expense/update-expense";
export const DELETE_EXPENSE = "/api/expense/delete-expense";
export const GET_PARENTS_MONTHLY_EXPENSE = "/api/expense/get-parents-monthly-expense"; 
export const GET_EXPENSE_STATISTICS = "/api/expense/statistics";
//CHATS
export const GET_CHATS = "/api/messaging/chat-contact-list";
export const GET_GROUPS = "/groups";
export const GET_CONTACTS = "/contacts";
export const GET_MESSAGES = "/api/messaging/fetch-messages";
export const ADD_MESSAGE = "/api/messaging/send-direct-message";
export const GET_CHAT_POLLING = "/api/messaging/polling-messages";


//moderator message
export const SEND_MODERATOR_MESSAGE = "/api/messaging/send-moderator-message";
//infoBank
export const GET_INFORMATION = "/api/info-bank/fetch-info-bank";
export const ADD_NEW_INFORMATION = "/api/info-bank/create-info-bank";
export const UPDATE_INFORMATION = "/api/infobank/update-information";
export const DELETE_INFORMATION = "/api/info-bank/delete-info-bank";
export const GET_DOCUMENT = "/api/infobank/get-document";
export const ADD_NEW_DOCUMENT = "/api/infobank/create-document";
export const UPDATE_DOCUMENT = "/api/infobank/update-document";
export const DELETE_DOCUMENT = "/api/infobank/delete-document";

//journals
export const GET_JOURNALS = "/api/journal/fetch-journal";
export const ADD_NEW_JOURNAL = "/api/journal/create-journal";
export const UPDATE_JOURNAL = "/api/journal/update-journal";
export const DELETE_JOURNAL = "/api/journal/delete-journal";
export const GET_JOURNAL_BY_ID = "/api/journal/get-journal";

//parenting space
export const GET_PARENTING_SPACE_USER_LIST = "/api/spaces/get-user-list";
export const REMOVE_SPACE_MEMBER = "/api/spaces/remove-space-member";
export const GET_USER_BY_ID = "/api/spaces/get-user-by-id";

//ORDERS
export const GET_ORDERS = "/orders";
export const ADD_NEW_ORDER = "/add/order";
export const UPDATE_ORDER = "/update/order";
export const DELETE_ORDER = "/delete/order";

//CART DATA
export const GET_CART_DATA = "/cart";

//CUSTOMERS
export const GET_CUSTOMERS = "/customers";
export const ADD_NEW_CUSTOMER = "/add/customer";
export const UPDATE_CUSTOMER = "/update/customer";
export const DELETE_CUSTOMER = "/delete/customer";

//SHOPS
export const GET_SHOPS = "/shops";

//CRYPTO
export const GET_WALLET = "/wallet";
export const GET_CRYPTO_ORDERS = "/crypto/orders";

//INVOICES
export const GET_INVOICES = "/invoices";
export const GET_INVOICE_DETAIL = "/invoice";

//PROJECTS
export const GET_PROJECTS = "/projects";
export const GET_PROJECT_DETAIL = "/project";
export const ADD_NEW_PROJECT = "/add/project";
export const UPDATE_PROJECT = "/update/project";
export const DELETE_PROJECT = "/delete/project";

//TASKS
export const GET_TASKS = "/tasks";

//CONTACTS
export const GET_USERS = "/users";
export const GET_USER_PROFILE = "/user";
export const ADD_NEW_USER = "/add/user";
export const UPDATE_USER = "/update/user";
export const DELETE_USER = "/delete/user";

//dashboard charts data
export const GET_WEEKLY_DATA = "/weekly-data";
export const GET_YEARLY_DATA = "/yearly-data";
export const GET_MONTHLY_DATA = "/monthly-data";

export const TOP_SELLING_DATA = "/top-selling-data";

export const GET_EARNING_DATA = "/earning-charts-data";

export const GET_PRODUCT_COMMENTS = "/comments-product";

export const ON_LIKNE_COMMENT = "/comments-product-action";

export const ON_ADD_REPLY = "/comments-product-add-reply";

export const ON_ADD_COMMENT = "/comments-product-add-comment";

// Credit Management APIs
export const GET_USER_CREDIT = "/api/credit";
export const GET_USER_CREDIT_TRANSACTIONS = "/api/credit/transactions";
export const GET_ALL_USERS_CREDITS = "/api/admin/user-credit/all";
export const GET_USER_CREDIT_BY_ID = "/api/admin/user-credit";
export const ADD_USER_CREDIT = "/api/admin/user-credit/add";
export const GET_USER_CREDIT_TRANSACTIONS_BY_ID = "/api/admin/user-credit/transactions";

// Subscription Management APIs
export const GET_USER_SUBSCRIPTION_STATUS = "/api/subscription/status";
export const GET_USER_SUBSCRIPTION_BY_ID = "/api/admin/user-subscription";
export const ACTIVATE_USER_SUBSCRIPTION = "/api/admin/user-subscription";
export const DEACTIVATE_USER_SUBSCRIPTION = "/api/admin/user-subscription";
